// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2oXvP","colCheckbox":"styles_colCheckbox__122la"};